// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__1Z23z"};